import Color from 'color';

export function isDark(solidColor) {
  const colorObj = Color(solidColor);
  const rgb = colorObj.rgb().color;
  // YIQ equation from http://24ways.org/2010/calculating-color-contrast
  const yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
  // return yiq < 128;
  return yiq < 140; // pagehits modified
}

export function isLight(solidColor) {
  return !isDark(solidColor);
}



// WEBPACK FOOTER //
// ./scripts/modules/colorHelper.js